import { get } from '..';
import { applySolveAnalyticsFilters, GetSolveAnalyticsStatsProps } from './Utils';

const GetSLAViolationsPerAsset = (props: GetSolveAnalyticsStatsProps) => {
  const baseUrl: string = 'solve-analytics/sla-violations-per-asset';
  const url: string = applySolveAnalyticsFilters(baseUrl, props);
  return get(url);
};

export default GetSLAViolationsPerAsset;
